import { useCallback, useState } from "react";

import { SalesRequest } from "~/types/client";

export const useOrderSelection = () => {
  const [selectedOrderIds, setSelectedOrderIds] = useState<Set<string>>(
    new Set()
  );

  const handleSelectOrder = useCallback((orderId: string) => {
    setSelectedOrderIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(orderId)) {
        newSet.delete(orderId);
      } else {
        newSet.add(orderId);
      }
      return newSet;
    });
  }, []);

  const handleSelectAll = useCallback((orders: SalesRequest[]) => {
    setSelectedOrderIds((prev) => {
      const allSelected = orders.every((order) => prev.has(order.id));
      if (allSelected) {
        return new Set();
      } else {
        return new Set(orders.map((o) => o.id));
      }
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedOrderIds(new Set());
  }, []);

  const getSelectedOrders = useCallback(
    (orders: SalesRequest[]) => {
      return orders.filter((order) => selectedOrderIds.has(order.id));
    },
    [selectedOrderIds]
  );

  const isAllSelected = useCallback(
    (orders: SalesRequest[]) => {
      return orders.length > 0 && orders.every((o) => selectedOrderIds.has(o.id));
    },
    [selectedOrderIds]
  );

  return {
    selectedOrderIds,
    handleSelectOrder,
    handleSelectAll,
    clearSelection,
    getSelectedOrders,
    isAllSelected,
  };
};
